import { FC, useContext, useMemo } from 'react';
import { isMobile } from 'react-device-detect';
import {
  CategoryPageContext,
  CategoryPageLoadedContext,
} from 'src/constructors/pageConstructors/CategoryPageConstructor';
import { HomePageContext, HomePageLoadedContext } from 'src/constructors/pageConstructors/HomePageConstructor';
import BannerSlider from './BannerSlider';

type Props = {
  settings: any;
  type: string;
};

const Slider: FC<Props> = ({ settings, type }) => {
  const homePageContext = useContext(HomePageContext);
  const categoryPageContext = useContext(CategoryPageContext);
  const homeLoaded = useContext(HomePageLoadedContext);
  const categoryLoaded = useContext(CategoryPageLoadedContext);

  const sliderData = useMemo(() => {
    switch (type) {
      case 'home':
        return isMobile
          ? homePageContext?.pageFields?.sliderMobile?.[0]
          : homePageContext?.pageFields?.sliderDesktop?.[0];
      case 'category':
        return isMobile
          ? categoryPageContext?.pageFields?.sliderMobile?.[0]
          : categoryPageContext?.pageFields?.sliderDesktop?.[0];
      default:
        return null;
    }
  }, [homePageContext, categoryPageContext, settings?.data?.pageContext]);

  return (
    <BannerSlider settings={settings.data.settings} sliderData={sliderData} pageLoaded={homeLoaded || categoryLoaded} />
  );
};
export default Slider;
